<template>
  <a-form-model
    ref="editReferenceIndexForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item label="Name" prop="name" class="mr-4 flex-1">
        <a-input v-model="form.name" class="w-full" />
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item
        label="Reporting currency"
        prop="currency"
        class="mr-4 flex-1"
      >
        <a-select v-model="form.currency" showSearch>
          <a-select-option
            v-for="currency in currencies"
            :key="currency"
            :value="currency"
          >
            {{ currency }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item label="Ticker" prop="ticker" class="mr-4 flex-1">
        <a-input v-model="form.ticker" class="w-full" />
      </a-form-model-item>
    </div>
    <a-button
      type="primary"
      html-type="submit"
      :disabled="isSaving || !form.name || !form.currency"
    >
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'
import currencies from '../../data/Currencies'

export default {
  props: {
    index: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: this.index ? this.index.name : '',
        isin: this.index ? this.index.ticker : '',
        currency: this.index ? this.index.currency : '',
      },
      isSaving: false,
      currencies,
    }
  },
  methods: {
    async handleSubmit() {
      if (this.form.name && this.form.currency) {
        try {
          this.isSaving = true
          if (this.index) {
            await this.updateReferenceIndex()
          } else {
            await this.addReferenceIndex()
          }
          this.isSaving = false
          this.$refs.editReferenceIndexForm.resetFields()
          this.$emit('reference-index-saved')
        } catch (error) {
          this.$message.error(error.message)
          this.isSaving = false
        }
      } else {
        return false
      }
    },
    async addReferenceIndex() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: AddReferenceIndexInput) {
            addReferenceIndex(input: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            name: this.form.name,
            ticker: this.form.ticker,
            currency: this.form.currency,
          },
        },
      })
    },
    async updateReferenceIndex() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: UpdateReferenceIndexInput) {
            updateReferenceIndex(input: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            id: this.index.id,
            name: this.form.name,
            ticker: this.form.ticker,
            currency: this.form.currency,
          },
        },
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancel-button-clicked')
      this.$refs.editReferenceIndexForm.resetFields()
    },
  },
  watch: {
    index(newVal) {
      this.form.name = newVal ? newVal.name : ''
      this.form.ticker = newVal ? newVal.ticker : ''
      this.form.currency = newVal ? newVal.currency : ''
    },
  },
}
</script>

<style></style>
